import { render, staticRenderFns } from "./base-ErrorPanel.vue?vue&type=template&id=2fa5f441&"
import script from "./base-ErrorPanel.vue?vue&type=script&lang=js&"
export * from "./base-ErrorPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports